import { HandleType } from '@xyflow/react'

export const getNodeHandleId = ({
  nodeId,
  type,
  handleMapping
}: {
  nodeId: string
  type: HandleType
  handleMapping?: string
}): string => {
  return [nodeId, type, handleMapping].filter(Boolean).join(':')
}
